import { render, staticRenderFns } from "./LocationOnIcon.vue?vue&type=template&id=b4e4d4ba"
import script from "./LocationOnIcon.vue?vue&type=script&lang=js"
export * from "./LocationOnIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports